var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 108,
    viewBox: "0 0 288 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1368_2480)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.029 67.4962C232.349 72.173 224.761 72.173 220.08 67.4962C177.959 25.4051 109.666 25.4051 67.5443 67.4962C62.8641 72.173 55.276 72.173 50.5958 67.4962C45.9156 62.8194 45.9156 55.2369 50.5958 50.5601C102.078 -0.884617 185.547 -0.884614 237.029 50.5601C241.709 55.2369 241.709 62.8195 237.029 67.4962ZM237.028 219.922C241.709 224.598 241.709 232.181 237.028 236.858C185.546 288.303 102.077 288.303 50.5952 236.858C45.915 232.181 45.915 224.598 50.5952 219.922C55.2754 215.245 62.8635 215.245 67.5437 219.922C109.665 262.013 177.958 262.013 220.08 219.922C224.76 215.245 232.348 215.245 237.028 219.922ZM203.132 101.369C198.452 106.045 190.864 106.045 186.184 101.369C162.783 77.9846 124.843 77.9846 101.442 101.369C96.7614 106.045 89.1733 106.045 84.4932 101.369C79.813 96.6918 79.813 89.1092 84.4932 84.4324C117.254 51.6949 170.371 51.6949 203.132 84.4324C207.813 89.1092 207.813 96.6918 203.132 101.369ZM203.132 186.049C207.812 190.726 207.812 198.309 203.132 202.986C170.371 235.723 117.254 235.723 84.4927 202.985C79.8125 198.309 79.8125 190.726 84.4927 186.049C89.1729 181.373 96.761 181.373 101.441 186.049C124.842 209.433 162.783 209.433 186.184 186.049C190.864 181.373 198.452 181.373 203.132 186.049ZM143.812 107.782C163.669 107.782 179.765 123.867 179.765 143.709C179.765 163.551 163.669 179.636 143.812 179.636C123.956 179.636 107.859 163.551 107.859 143.709C107.859 123.867 123.956 107.782 143.812 107.782Z",
    fill: "#CD001A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1368_2480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107.781,
    height: 287.625,
    fill: "white",
    transform: "translate(287.625) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal);
export default __webpack_public_path__ + "static/media/signal.63dcee597afc9bfa49d9275023e845c7.svg";
export { ForwardRef as ReactComponent };